import { render, staticRenderFns } from "./GuestLayout.vue?vue&type=template&id=2b0b63d1&"
import script from "./GuestLayout.vue?vue&type=script&lang=js&"
export * from "./GuestLayout.vue?vue&type=script&lang=js&"
import style0 from "./GuestLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VApp } from 'vuetify/lib/components/VApp';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VAlert,VApp,VIcon,VMain})
